import React from 'react';
import s from './pagination.module.scss';

function Pagination({
  influencersPerPage,
  totalInfluencers,
  setCurrentPage,
  currentPage,
  ...props
}) {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalInfluencers / influencersPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <nav className={s.nav}>
      <a
        href="#allInfluencers"
        onClick={() => {
          if (currentPage !== 1) return setCurrentPage(currentPage - 1);
        }}
        className={`${s.prev} ${currentPage !== 1 && s.show}`}
      >
        {'< Previous'}
      </a>
      <ul className={s.list}>
        {pageNumbers.map(number => {
          if (currentPage < 4) {
            if (number < 6) {
              return (
                <a href="#allInfluencers">
                  <li
                    onClick={() => setCurrentPage(number)}
                    className={`${s.number} ${number === currentPage &&
                      s.currentPage}`}
                    key={number}
                  >
                    {number}
                    {' '}
                  </li>
                </a>
              );
            }
            if (number === pageNumbers.length) {
              return (
                <>
                  <li className={`${s.number} ${s.points}`}>...</li>
                  <a href="#allInfluencers">
                    <li
                      onClick={() => setCurrentPage(number)}
                      className={`${s.number} ${number === currentPage &&
                        s.currentPage}`}
                      key={number}
                    >
                      {number}
                    </li>
                  </a>
                </>
              );
            }
          } else if (currentPage > pageNumbers.length - 3) {
            if (number === 1) {
              return (
                <>
                  <a href="#allInfluencers">
                    <li
                      onClick={() => setCurrentPage(number)}
                      className={`${s.number} ${number === currentPage &&
                        s.currentPage}`}
                      key={number}
                    >
                      {`${number} `}
                      {' '}
                    </li>
                  </a>
                  <li className={`${s.number} ${s.points}`}>...</li>
                </>
              );
            }
            if (number > pageNumbers.length - 5) {
              return (
                <a href="#allInfluencers">
                  <li
                    onClick={() => setCurrentPage(number)}
                    className={`${s.number} ${number === currentPage &&
                      s.currentPage}`}
                    key={number}
                  >
                    {' '}
                    {number}
                  </li>
                </a>
              );
            }
          } else {
            if (number === 1) {
              return (
                <>
                  <a href="#allInfluencers">
                    <li
                      onClick={() => setCurrentPage(number)}
                      className={`${s.number} ${number === currentPage &&
                        s.currentPage}`}
                      key={number}
                    >
                      {number}
                    </li>
                  </a>
                  <li className={`${s.number} ${s.points}`}>...</li>
                </>
              );
            }
            if (
              number === currentPage - 1 ||
              number === currentPage ||
              number === currentPage + 1
            ) {
              return (
                <a href="#allInfluencers">
                  <li
                    onClick={() => setCurrentPage(number)}
                    className={`${s.number} ${number === currentPage &&
                      s.currentPage}`}
                    key={number}
                  >
                    {number}
                    {' '}
                  </li>
                </a>
              );
            }
            if (number === pageNumbers.length) {
              return (
                <>
                  <li className={`${s.number} ${s.points}`}>...</li>
                  <a href="#allInfluencers">
                    <li
                      onClick={() => setCurrentPage(number)}
                      className={`${s.number} ${number === currentPage &&
                        s.currentPage}`}
                      key={number}
                    >
                      {number}
                    </li>
                  </a>
                </>
              );
            }
          }
        })}
      </ul>
      <a
        href="#allInfluencers"
        onClick={() => {
          if (currentPage !== pageNumbers.length) return setCurrentPage(currentPage + 1);
        }}
        className={`${s.next} ${currentPage !== pageNumbers.length && s.show}`}
      >
        {'Next >'}
      </a>
    </nav>
  );
}

export default Pagination;
